/**
 * Ecolabel pills shared by the spot table and the forwards picker, so a label looks the same in both.
 *
 * The pill carries the ecolabel's brand name, which is not translated.
 */

const BRAND_NAMES: Record<string, string> = {
  ekoenergy: "EKOenergy",
  okpower: "OK-power",
  okpower_new: "OK-power new",
};

const BADGE_CLASSES: Record<string, string> = {
  ekoenergy: "bg-success-subtle text-success-emphasis",
  okpower_new: "bg-info-subtle text-info-emphasis",
};

const DEFAULT_BADGE_CLASS = "bg-secondary-subtle text-secondary-emphasis";

/** Accepts both spellings in use: the spot table's `okpower-new` tag and the forwards `okpower_new` key. */
const normalized = (key: string): string => key.replaceAll("-", "_");

/** The ecolabel's brand name for a pill; an unknown key is shown as it is. */
export const ecolabelBrandName = (key: string): string =>
  BRAND_NAMES[normalized(key)] ?? key;

/** The Bootstrap colour classes of an ecolabel pill. */
export const ecolabelBadgeClass = (key: string): string =>
  BADGE_CLASSES[normalized(key)] ?? DEFAULT_BADGE_CLASS;
